<template>
  <main class="page-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="measure ol-unselectable ol-control" v-show="measuring">
            <div class="measure-inner">
              Długość:
              <span v-text="length"></span>
              <br />Powierzchnia:
              <span v-html="area"></span>
            </div>
          </div>
          <div class="top-options">
            <ul>
              <li class="pointer" v-tooltip.auto="$t('tooltip.move')">
                <div>
                  <i class="fas fa-mouse-pointer"></i>
                </div>
              </li>
              <li
                class="minus"
                v-tooltip.auto="$t('tooltip.line')"
                @click="addMeasure"
                v-show="!measuring"
              >
                <div>
                  <i class="fas fa-ruler"></i>
                </div>
              </li>
              <li
                class="minus"
                v-tooltip.auto="$t('tooltip.finishMeasure')"
                @click="removeMeasure"
                v-show="measuring"
              >
                <div>
                  <i class="fas fa-times"></i>
                </div>
              </li>
              <li class="search" v-tooltip.auto="$t('tooltip.box')" @click="addZoom">
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </li>
              <li
                class="print"
                v-tooltip.auto="$t('tooltip.print')"
                @click="$modal.show('modal-map-printing');showModalMapPrinting=true;"
              >
                <div>
                  <i v-if="!gminyLoaded" class="fas fa-spinner fa-spin"></i>
                  <img v-if="gminyLoaded" src="img/printer.svg" />
                </div>
              </li>
              <li class="screenshot" ref="export_png" v-tooltip.auto="$t('tooltip.screenshot')">
                <div>
                  <i v-if="!pngLoaded" class="fas fa-spinner fa-spin"></i>
                  <i v-if="pngLoaded" class="fas fa-camera"></i>
                </div>
              </li>
              <li
                class="share"
                v-tooltip.auto="$t('tooltip.share')"
                @click="$modal.show('sms-modal');"
              >
                <div>
                  <i class="fas fa-share-alt"></i>
                </div>
              </li>
            </ul>
          </div>
          <div class="map-loadings set-left-on-toggled">
            <div class="map-loadingg-loading" v-if="sourcesLoading.kieg">
              <i class="fas fa-spinner fa-spin"></i>
              {{$t('maploading.loading')}}: {{$t('legend.kieg')}}
            </div>
            <template v-if="activeLayers.wms['wms-kiut']">
              <div class="map-loadingg-loading" v-if="currentZoom < 19">
                <i class="fas fa-exclamation-triangle"></i>
                {{$t('maploading.zoom_in')}}: {{$t('legend.kiut')}}
              </div>
              <div class="map-loadingg-loading" v-else-if="sourcesLoading.kiut">
                <i class="fas fa-spinner fa-spin"></i>
                {{$t('maploading.loading')}}: {{$t('legend.kiut')}}
              </div>
            </template>
            <div class="map-loadingg-loading" v-if="sourcesLoading['dzialki-layer']">
              <i class="fas fa-spinner fa-spin"></i>
                {{$t('maploading.loading')}}: {{$t('legend.surface')}}
            </div>
          </div>
          <div class="map-layers set-left-on-toggled" id="map-layers">
            <div class="map-layers-btns">
              <div class="map-layers-btn">
                <ul>
                  <li class="pointer" v-on:click="showMapLayers = !showMapLayers">
                    <a id="map-layers-fn">
                      <i class="fas fa-layer-group"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <ul class="map-layers-shortcuts">
                <li>
                  <input
                    type="checkbox"
                    name="mapLayersItem"
                    id="mapLayers_17s"
                    class="form-radio"
                    v-model="activeLayers.ficzery"
                    @click.stop="toggleLayer('ficzery', $event, true)"
                  />
                  <label for="mapLayers_17s" class="css-label">
                    {{ $t("legend.available") }}
                    <div :class="`pattern ficzery`"></div>
                  </label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    name="mapLayersItem"
                    id="mapLayers_18s"
                    class="form-radio"
                    v-model="activeLayers.ficzeryZainwest"
                    @click.stop="toggleLayer('ficzeryZainwest', $event, true)"
                  />
                  <label for="mapLayers_18s" class="css-label">
                    {{ $t("legend.invested") }}
                    <div :class="`pattern ficzeryZainwest`"></div>
                  </label>
                </li>
              </ul>
            </div>
            <transition name="fade">
              <div class="map-layers-menu" v-show="showMapLayers">
                <div class="map-layers-vuebar" v-bar>
                  <div>
                    <ul>
                      <li class="list-title">
                        <span>{{ $t("legend.maps") }}</span>
                      </li>
                      <li v-for="(item, idx) of basemapLayers" :key="`mapLayersBasemap${idx}`">
                        <input
                          type="radio"
                          class="form-radio"
                          :id="`mapLayersBasemap${idx}`"
                          :value="item.name"
                          v-model="basemap"
                        />
                        <label :for="`mapLayersBasemap${idx}`">{{ $t(`legend.${item.name}`) }}</label>
                      </li>
                    </ul>
                    <ul>
                      <li class="list-title">
                        <span>{{ $t("legend.record") }}</span>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_8"
                          class="form-radio"
                          v-model="activeLayers.dzialki"
                          @click.stop="toggleLayer('dzialki-layer', $event)"
                        />
                        <label for="mapLayers_8" class="css-label">{{ $t("legend.surface") }}</label>
                      </li>
                      <li>
                        <input
                          @click="toggleLayer(`wms-kieg`);"
                          type="checkbox"
                          :id="`mapLayersWMSkieg`"
                          class="form-radio"
                        />
                        <label :for="`mapLayersWMSkieg`" class="css-label">
                          {{ $t(`legend.kieg`) }}
                          <div :class="`pattern kieg`"></div>
                        </label>
                      </li>
                      <li>
                        <input
                          @click="toggleLayer(`wms-kiut`);"
                          type="checkbox"
                          :id="`mapLayersWMSkiut`"
                          class="form-radio"
                        />
                        <label :for="`mapLayersWMSkiut`" class="css-label">
                          {{ $t(`legend.kiut`) }}
                          <div :class="`pattern kiut`"></div>
                        </label>
                      </li>
                    </ul>
                    <ul>
                      <li class="list-title">
                        <span>{{ $t("legend.infrastructure") }}</span>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_9"
                          class="form-radio"
                          v-model="activeLayers.media.prad"
                        />
                        <label for="mapLayers_9" class="css-label">{{ $t("legend.energy") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_10"
                          class="form-radio"
                          v-model="activeLayers.media.woda"
                        />
                        <label for="mapLayers_10" class="css-label">{{ $t("legend.water") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_23"
                          class="form-radio"
                          v-model="activeLayers.media.sanit"
                        />
                        <label for="mapLayers_23" class="css-label">{{ $t("legend.sewer") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_11"
                          class="form-radio"
                          v-model="activeLayers.media.gaz"
                        />
                        <label for="mapLayers_11" class="css-label">{{ $t("legend.gas") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_12"
                          class="form-radio"
                          v-model="activeLayers.media.telekom"
                        />
                        <label for="mapLayers_12" class="css-label">{{ $t("legend.teltech") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_13"
                          class="form-radio"
                          v-model="activeLayers.media.deszcz"
                        />
                        <label for="mapLayers_13" class="css-label">{{ $t("legend.rain") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_14"
                          class="form-radio"
                          v-model="activeLayers.media.connection"
                        />
                        <label for="mapLayers_14" class="css-label">{{ $t("legend.connection") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_15"
                          class="form-radio"
                          v-model="activeLayers.media.parking"
                        />
                        <label for="mapLayers_15" class="css-label">{{ $t("legend.parking") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_16"
                          class="form-radio"
                          v-model="activeLayers.media.roads"
                        />
                        <label for="mapLayers_16" class="css-label">{{ $t("legend.roads") }}</label>
                      </li>
                    </ul>
                    <ul>
                      <li class="list-title">
                        <span>{{ $t("legend.category") }}</span>
                      </li>

                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_17"
                          class="form-radio"
                          v-model="activeLayers.ficzery"
                          @click.stop="toggleLayer('ficzery', $event)"
                        />
                        <label for="mapLayers_17" class="css-label">
                          {{ $t("legend.available") }}
                          <div :class="`pattern ficzery`"></div>
                        </label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_18"
                          class="form-radio"
                          v-model="activeLayers.ficzeryZainwest"
                          @click.stop="toggleLayer('ficzeryZainwest', $event)"
                        />
                        <label for="mapLayers_18" class="css-label">
                          {{ $t("legend.invested") }}
                          <div :class="`pattern ficzeryZainwest`"></div>
                        </label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_19"
                          class="form-radio"
                          v-model="activeLayers.hale"
                          @click.stop="toggleLayer('hale-layer', $event)"
                        />
                        <label for="mapLayers_19" class="css-label">{{ $t("legend.halls") }}</label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="mapLayersItem"
                          id="mapLayers_20"
                          class="form-radio"
                          v-model="activeLayers.biura"
                          @click.stop="toggleLayer('biura-layer', $event)"
                        />
                        <label for="mapLayers_19" class="css-label">{{ $t("legend.offices") }}</label>
                      </li>
                    </ul>
                    <ul>
                      <li class="list-title">
                        <span>{{ $t("legend.mapservices") }}</span>
                      </li>
                      <li v-for="(item, idx) of displayWmsLayers" :key="`mapLayersWMS${idx}`">
                        <input
                          @click="toggleLayer(`wms-${item.name}`);"
                          type="checkbox"
                          :id="`mapLayersWMS${idx}`"
                          class="form-radio"
                        />
                        <label :for="`mapLayersWMS${idx}`" class="css-label">
                          {{ $t(`legend.${item.name}`) }}
                          <div :class="`pattern ${item.name}`"></div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div id="map" class="map"></div>
        </div>
      </div>
    </div>
    <modal
      class="modal-map-printing"
      name="modal-map-printing"
      :draggable="isMobile() ? false : '.modal-header'"
      width="900"
      height="auto"
      v-show="showModalMapPrinting"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("mapprinting.title") }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="showModalMapPrinting=false"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <MapPrinting :parentMap="map" />
        </div>
      </div>
    </modal>
    <modal
      class="modal-map-media"
      name="modal-map-media"
      :draggable="isMobile() ? false : '.modal-header'"
      width="500px"
      height="auto"
      @closed="modalMapMedia = undefined"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("mapmedia.title") }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$modal.hide('modal-map-media')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table v-if="modalMapMedia">
            <tr>
              <td>{{$t("mapmedia.typ")}}:</td>
              <td>{{$t(`mapmedia.typy.${modalMapMedia.typ}`)}}</td>
            </tr>
            <tr>
              <td>{{$t("mapmedia.etykieta")}}:</td>
              <td>{{modalMapMedia[`etykieta_${getLang()}`] | showInLangField(getLang())}}</td>
            </tr>
            <tr>
              <td>{{$t("mapmedia.komentarze")}}:</td>
              <td>{{modalMapMedia.komentarze[0] && modalMapMedia.komentarze[0] | showInLang(getLang())}}</td>
            </tr>
          </table>

          <div class="buttons">
            <b-button
              variant="success"
              @click="$modal.hide('modal-map-media')"
            >{{ $t("mapmedia.btn") }}</b-button>
          </div>
        </div>
      </div>
    </modal>
    <SocialMediaModal />
  </main>
</template>
<script>
import SocialMediaModal from "../components/modals/SocialMediaModal";
import MapPrinting from "../components/MapPrinting.vue";
import Map from "ol/Map";
import { fromLonLat, get as getProjection } from "ol/proj";
import { register } from "ol/proj/proj4.js";
import proj4 from "proj4";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import { defaults as defaultControls, ScaleLine } from "ol/control.js";
import VectorLayer from "ol/layer/Vector";
import VectorTileLayer from "ol/layer/VectorTile";
import MVT from "ol/format/MVT";
import VectorTileSource from "ol/source/VectorTile";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON.js";
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
  Icon
} from "ol/style.js";
import Draw, { createBox } from "ol/interaction/Draw";
import LineString from "ol/geom/LineString";
import { getArea, getLength } from "ol/sphere.js";
import XYZ from "ol/source/XYZ";
import TileWMS from "ol/source/TileWMS.js";
import { pointerMove } from "ol/events/condition.js";
import Select from "ol/interaction/Select.js";
import { getCenter } from "ol/extent";
import CartogramMapMixin from "@/mixins/CartogramMapMixin";
import Overlay from "ol/Overlay.js";
import Point from "ol/geom/Point.js";
import FileSaver from "file-saver";
import MediaStyle from "@/components/mediaStyle.js";
import Layers from "@/components/layers.js";
import { Image as ImageLayer } from "ol/layer.js";
import ImageWMS from "ol/source/ImageWMS.js";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { WMTS } from "ol/source";
import { imgToSmallSrc } from "../img";

const listTypeToLayer = {
  tereny: "invest_areas",
  hale: "industrial_hall",
  biura: "offices",
};

export default {
  mixins: [CartogramMapMixin],
  data: function() {
    return {
      modalMapMedia: undefined,

      lockedVisibleLayers: {},
      sourcesLoading: {
        kieg: 0,
        kiut: 0,
        'dzialki-layer': 0,
      },
      currentZoom: 0,

      basemap: "",
      activeLayers: {
        wms: {},
        media: {
          prad: false,
          woda: false,
          sanit: false,
          gaz: false,
          telekom: false,
          deszcz: false,
          connection: false,
          parking: false,
          roads: false
        },
        ficzery: false,
        ficzeryZainwest: false,
        dzialki: false,
        hale: true,
        biura: true
      },
      wmsLayers: Layers.wms,
      basemapLayers: Layers.basemaps,
      cartogramActive: false,
      gminyLoaded: false,
      pngLoaded: true,
      showModalMapPrinting: false,
      offersJSON: {},
      offersJSONZainwest: {},
      map: undefined,
      measuringTool: undefined,
      editingSource: undefined,
      zoomTool: undefined,
      measuring: false,
      zooming: false,
      area: "0 m<sup>2</sup>",
      length: "0 m",
      show: false,
      showMapLayers: false,
      defaultCircleStyle: new Style({
        image: new CircleStyle({
          radius: 20,
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.6)"
          })
        }),
        text: new Text({
          font: "12px Calibri,sans-serif",
          fill: new Fill({
            color: "#000"
          }),
          stroke: new Stroke({ color: "#fff", width: 3 })
        })
      }),
      defaultStyle: new Style({
        fill: new Fill({
          color: "rgba(255, 255, 255, 1)"
        }),
        stroke: new Stroke({ color: "#ffffff", width: 0.1 }),
        text: new Text({
          backgroundFill: new Fill({ color: "#ffffff" }),
          padding: [15, 15, 15, 15],
          font: "12px Calibri,sans-serif",
          fill: new Fill({
            color: "#000"
          }),
          stroke: new Stroke({ color: "#fff", width: 3 })
        })
      }),
      ficzerySource: new VectorSource({
        format: new GeoJSON({ featureProjection: "EPSG:3857" })
      }),
      ficzery_source_cache: undefined,
      powiatySource: new VectorSource({
        format: new GeoJSON({ featureProjection: "EPSG:3857" })
      }),
      powiatyLabelsSource: new VectorSource(),
      gminyLabelsSource: new VectorSource(),
      gminySource: new VectorSource({
        format: new GeoJSON({ featureProjection: "EPSG:3857" })
      }),
      gminy_source_cache: undefined,
      gminy_labels_cache: undefined,
      powiatyLayer: undefined,
      gminyLayer: undefined,
      ficzeryLayer: undefined,
      powiatyLabelsLayer: undefined,
      gminyLabelsLayer: undefined,
      selectionLayer: undefined,
      wmtsTilegrid: new WMTSTileGrid({
        origin: [-20037508.34, 20037508.34],
        matrixIds: [
          "EPSG:3857:0",
          "EPSG:3857:1",
          "EPSG:3857:2",
          "EPSG:3857:3",
          "EPSG:3857:4",
          "EPSG:3857:5",
          "EPSG:3857:6",
          "EPSG:3857:7",
          "EPSG:3857:8",
          "EPSG:3857:9",
          "EPSG:3857:10",
          "EPSG:3857:11",
          "EPSG:3857:12",
          "EPSG:3857:13",
          "EPSG:3857:14",
          "EPSG:3857:15",
          "EPSG:3857:16",
          "EPSG:3857:17",
          "EPSG:3857:18",
          "EPSG:3857:19",
          "EPSG:3857:20"
        ],
        resolutions: [
          156543.03390625,
          78271.516953125,
          39135.7584765625,
          19567.87923828125,
          9783.939619140625,
          4891.9698095703125,
          2445.9849047851562,
          1222.9924523925781,
          611.4962261962891,
          305.74811309814453,
          152.87405654907226,
          76.43702827453613,
          38.218514137268066,
          19.109257068634033,
          9.554628534317017,
          4.777314267158508,
          2.388657133579254,
          1.194328566789627,
          0.5971642833948135,
          0.2985821416974068,
          0.1492910708487034
        ],
        tileSize: 256
      }),
      searchFilterSetted: false,
      gminyGeojson: undefined
    };
  },
  components: {
    MapPrinting,
    SocialMediaModal
  },
  computed: {
    displayWmsLayers() {
      return this.wmsLayers.filter(item => item.displayType != "records");
    },
    mapReady() {
      // Wymagane do liczenia przy filtrowaniu gmin
      return this.gminyLoaded && this.ficzeryZainwestLayer;
    },
    currentCenter() {
      // this.gminyLoaded - wymagane do odpowiedniego filtrowania gmin przy centerOn powiat
      return this.mapReady && this.$store.getters.currentCenter;
    },
    mediaLayersWatcher() {
      return Object.keys(this.activeLayers.media)
        .map(k => this.activeLayers.media[k])
        .join();
    },
    explodedOferty() {
      if (
        !this.$store.getters["tereny/loaded"] ||
        !this.$store.getters["inwestorzy/loaded"]
      ) {
        return undefined;
      }

      let exploded = [];

      let add = listType => {
        this.$store.getters[`${listType}/features`].forEach(feature => {
          if (feature.geometry.type !== "MultiPolygon") {
            console.warning(
              `Invalid geometry type`,
              // getter,
              feature.geometry.type
            );
            return;
          }
          feature.geometry.coordinates.forEach(coordinates => {
            exploded.push({
              type: "Feature",
              geometry: {
                coordinates: coordinates,
                type: "Polygon"
              },
              properties: {
                listType,
                id: feature.id
              }
            });
          });
        });
      };

      add("tereny");
      add("inwestorzy");

      return exploded;
    },
    searchFilter() {
      if (this.$store.getters[`search/active`]) {
        let filter = this.$store.getters[`search/filter`];
        let array = this.$store.getters[`${filter.listType}/filter`](filter);
        let searchFilter = {
          layer: listTypeToLayer[filter.listType],
          features: array,
          type: "FeatureCollection"
        };
        return searchFilter;
      } else {
        return undefined
      }
    },
    searchFilterDoSet() {
      if (this.mapReady) {
        return this.searchFilter
      } else {
        return false
      }
    },
    searchFilterDoReset() {
      if (this.mapReady) {
        return this.searchFilter === undefined;
      } else {
        return false
      }
    }
  },
  watch: {
    gminyLoaded(gminyLoaded) {
      console.debug("gminyLoaded", gminyLoaded)
    },
    modalMapMedia(){
      this.getLayerByName("media-layer").getSource().refresh();
    },
    explodedOferty(exploded) {
      if (exploded === undefined) {
        return;
      } else {
        if (this.explodedOfertyLayer) {
          this.map.removeLayer(this.explodedOfertyLayer);
        }
        this.explodedOfertyLayer = new VectorLayer({
          name: "explodedOferty",
          visible: false,
          source: new VectorSource({
            features: new GeoJSON().readFeatures(
              {
                type: "FeatureCollection",
                features: exploded
              },
              {
                featureProjection: "EPSG:3857"
              }
            )
          })
        });
        this.explodedOfertyLayer.setZIndex(-1); // pod terenami i inwestorami
        this.map.addLayer(this.explodedOfertyLayer);
      }
    },
    currentCenter(new_, old) {
      if (new_ === undefined) {
        return
      }
      let { type, item } = new_
      if (type == "strefa") {
        if (!(!old || old.type !== "strefa")) {
          return;
        }
      }
      this.centerOn({ type, item });
    },
    basemap(nV) {
      for (let layer of this.basemapLayers) {
        if (layer.name == nV) {
          this.getLayerByName(`basemap-${layer.name}`).setVisible(true);
        } else {
          this.getLayerByName(`basemap-${layer.name}`).setVisible(false);
        }
      }
    },
    mediaLayersWatcher() {
      let activeFeatures = Object.keys(this.activeLayers.media).filter(
        f => this.activeLayers.media[f] == true
      );
      if (activeFeatures.indexOf("connection") > -1) {
        activeFeatures = activeFeatures.concat([
          "zbiornik_ret",
          "stacja_redukcyjna",
          "gpz",
          "oczyszczalnia",
          "przepompownia",
          "zbiornik_ppoz",
          "zbiornik_ret"
        ]);
      }
      activeFeatures = activeFeatures.concat(
        activeFeatures.map(f => `plan_${f}`)
      );
      this.getLayerByName("media-layer").setStyle(f => {
        if (activeFeatures.indexOf(f.get("typ")) == -1) {
          if (f.getGeometry().getType() == "Point") {
            return new Style({
              image: new CircleStyle({
                fill: new Fill({
                  color: "rgba(0,0,0,0)"
                }),
                stroke: new Stroke({
                  color: "rgba(0,0,0,0)"
                })
              })
            });
          } else {
            return new Style({
              fill: new Fill({
                color: "rgba(0,0,0,0)"
              }),
              stroke: new Stroke({
                color: "rgba(0,0,0,0)"
              })
            });
          }
        } else {
          let style = MediaStyle[f.get("typ")].style;
          let width = 1;
          if (this.modalMapMedia && this.modalMapMedia.id == f.get("id")) {
            width = 3;
          }
          if (f.getGeometry().getType() == "Point") {
            return new Style({
              image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                  color: style.fillColor ? style.fillColor : "#000000"
                }),
                stroke: new Stroke({
                  color: style.strokeColor ? style.strokeColor : "#000000",
                  width: width
                })
              })
            });
          } else {
            return new Style({
              fill: new Fill({
                color: style.fillColor ? style.fillColor : "#000000"
              }),
              stroke: new Stroke({
                color: style.strokeColor ? style.strokeColor : "#000000",
                width: width,
                lineDash: style.strokeDashstyle ? [10, 10] : undefined
              })
            });
          }
        }
      });
    },
    searchFilterDoSet(searchFilter) {
      if (searchFilter && searchFilter !== this.searchFilterSetted) {
        console.debug("Setting search filter", searchFilter.features.length);
        this.executeFilter(searchFilter);
      }
    },
    searchFilterDoReset(doReset) {
      if (doReset && this.searchFilterSetted) {
        console.debug("Resetting search filter");
        this.resetFilter();
      }
    }
  },
  methods: {
    getLang() {
      return this.$i18n.i18next.language;
    },
    centerOn({ type, item }) {
      console.debug('centerOn', type, item)
      if (type == "strefa") {
        this.powiatyView();
      }
      if (item) {
        switch (type) {
          case "powiat":
            this.gminyView(item.nazwa);
            break;
          case "gmina":
            this.ofertyView(item.nazwa);
            break;
          case "terenyDetails":
            this.ofertaView(item);
            break;
          case "haleDetails":
            this.selectHala(item);
            break;
          case "biuraDetails":
            this.selectBiuro(item);
            break;
          case "inwestorzyDetails":
            this.ofertaViewS(item.properties.nazwa.pl);
            break;
        }
      }
    },
    executeFilter(filter) {
      if (filter.layer == "invest_areas") {
        this.loadFiczery(filter);
        this.centerOn(this.currentCenter);
      } else {
        this.powiatyLayer.setVisible(false);
        this.powiatyLabelsLayer.setVisible(false);
        this.gminyLayer.setVisible(false);
        this.gminyLabelsLayer.setVisible(false);
        this.ficzeryLayer.setVisible(false);
        this.map.removeEventListener("singleclick");
      }
      this.searchFilterSetted = filter;
    },
    resetFilter() {
      this.loadFiczery();
      this.centerOn(this.currentCenter);
      this.searchFilterSetted = false;
    },
    makePNG() {
      let mainThis = this;
      this.$refs.export_png.addEventListener("click", function() {
        mainThis.map.once("rendercomplete", function(event) {
          var canvas = event.context.canvas;
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(canvas.msToBlob(), "wsse_map.png");
          } else {
            canvas.toBlob(function(blob) {
              mainThis.pngLoaded = false;
              try {
                FileSaver.saveAs(blob, "wsse_map.png");
                mainThis.pngLoaded = true;
              } catch (e) {
                alert("Nie udało się zapisać.");
                mainThis.pngLoaded = true;
              }
            });
          }
        });
        mainThis.map.renderSync();
      });
    },
    getLayerByName(name) {
      return this.map
        .getLayers()
        .getArray()
        .filter(l => {
          return l.get("name") == name;
        })[0];
    },
    toggleLayer(name, event, lock = false) {
      if (!this.getLayerByName(name) && event) {
        event.preventDefault();
        return;
      }
      const nextVisible = !this.getLayerByName(name).getVisible();
      this.getLayerByName(name).setVisible(nextVisible);
      if (name.startsWith("wms-")) {
        this.activeLayers.wms = {
          ...this.activeLayers.wms,
          [name]: nextVisible
        };
      }
      if (lock) {
        this.lockedVisibleLayers[name] = nextVisible;
      }
    },
    setLayerVisibility(name, value) {
      let layer = this.getLayerByName(name);
      if (layer) {
        if (!value && this.lockedVisibleLayers[name]) {
          return;
        }
        layer.setVisible(value);
        this.activeLayers[name] = value;
      }
    },
    togglList() {
      this.show = !this.show;
    },
    addMeasure() {
      this.removeZoom();
      this.map.removeEventListener("singleclick");
      this.measuringTool = new Draw({
        type: "Polygon",
        source: this.editingSource
      });
      this.measuringTool.on("drawstart", eDraw => {
        this.editingSource.clear();
        eDraw.feature.on("change", eChange => {
          let measurementArea = getArea(eChange.target.getGeometry());
          this.area =
            measurementArea > 1000000
              ? `${(measurementArea / 1000000).toFixed(2)} km <sup>2</sup>`
              : `${measurementArea.toFixed(2)} m <sup>2</sup>`;
          let measurementLength = getLength(
            new LineString(
              eChange.target
                .getGeometry()
                .getLinearRing(0)
                .getCoordinates()
            )
          );
          this.length =
            measurementLength > 1000 * 2
              ? `${(measurementLength / 1000 / 2).toFixed(2)} km`
              : `${(measurementLength / 2).toFixed(2)} m`;
        });
      });
      this.map.addInteraction(this.measuringTool);
      this.measuring = true;
    },
    removeMeasure() {
      this.map.removeInteraction(this.measuringTool);
      this.editingSource.clear();
      this.area = "0 m";
      this.length = "0 m";
      this.measuring = false;
    },
    addZoom() {
      this.removeMeasure();
      this.map.removeEventListener("singleclick");
      this.zoomTool = new Draw({
        source: new VectorSource(),
        type: "Circle",
        geometryFunction: createBox(),
        freehandCondition: () => true
      });
      this.zoomTool.on("drawend", e => {
        this.map
          .getView()
          .fit(e.feature.getGeometry().getExtent(), { duration: 1000 });
        this.removeZoom();
      });
      this.map.addInteraction(this.zoomTool);
      this.zooming = true;
    },
    removeZoom() {
      this.map.removeInteraction(this.zoomTool);
      this.zooming = false;
      this.map.on("singleclick", e => this.singleClickCallback(e));
    },
    loadMVT() {
      let urlParams = {
        REQUEST: "GetTile",
        SERVICE: "WMTS",
        VERSION: "1.0.0",
        LAYER: "wsse:media",
        STYLE: "",
        FORMAT: "application/vnd.mapbox-vector-tile",
        TILEMATRIXSET: "EPSG:900913",
        TILEMATRIX: "EPSG:900913:{z}",
        TILECOL: "{x}",
        TILEROW: "{y}"
      };
      let url = `${process.env.VUE_APP_GEOSERVER_URL}/gwc/service/wmts?`;
      for (let param in urlParams) {
        url = `${url}${param}=${urlParams[param]}&`;
      }
      url = url.slice(0, -1);
      let source = new VectorTileSource({
        url: url,
        layer: urlParams.LAYER,
        format: new MVT({})
      });
      this.map.addLayer(
        new VectorTileLayer({
          name: "media-layer",
          source: source,
          style: f => {
            if (f.getGeometry().getType() == "Point") {
              return new Style({
                image: new CircleStyle({
                  fill: new Fill({
                    color: "rgba(0,0,0,0)"
                  }),
                  stroke: new Stroke({
                    color: "rgba(0,0,0,0)"
                  })
                })
              });
            } else {
              return new Style({
                fill: new Fill({
                  color: "rgba(0,0,0,0)"
                }),
                stroke: new Stroke({
                  color: "rgba(0,0,0,0)"
                })
              });
            }
          },
          visible: true,
          zIndex: 1
        })
      );
      urlParams.LAYER = "wsse:dzialki";
      url = `${process.env.VUE_APP_GEOSERVER_URL}/gwc/service/wmts?`;
      for (let param in urlParams) {
        url = `${url}${param}=${urlParams[param]}&`;
      }
      url = url.slice(0, -1);
      source = new VectorTileSource({
        url: url,
        layer: urlParams.LAYER,
        format: new MVT({})
      });
      this.map.addLayer(
        new VectorTileLayer({
          name: "dzialki-layer",
          source: source,
          style: f => {
            return new Style({
              fill: new Fill({
                color: "rgba(255,255,255,0.4)"
              }),
              stroke: new Stroke({
                color: "#ff4040"
              }),
              text: new Text({
                font: "10px sans-serif",
                text: f.get("numer")
              })
            });
          },
          visible: false
        })
      );
      this.addedSource('dzialki-layer', source)
    },
    loadGminy(run=true) {
      if (this.gminyGeojson === undefined) {
        this.$http.get("/jst_pub/gminy.geojson").then(myJson => {
          this.gminyGeojson = myJson.data;
          if (run) {
            this.afterLoadGminy()
          }
        });
      } else {
        if (run) {
          this.afterLoadGminy();
        }
      }
    },
    afterLoadGminy() {
      this.gminyLoaded = false;
      let myJson = this.gminyGeojson;

      let gminy_counts = {};
      let gminy_powierzch = {};
      this.ficzerySource.forEachFeature(function(f) {
        let gmina_id = f.get("gmina_id");
        let powierzch = f.get("powierzch");
        gminy_counts[gmina_id] = (gminy_counts[gmina_id] || 0) + 1;
        gminy_powierzch[gmina_id] = (gminy_powierzch[gmina_id] || 0) + powierzch;
      });

      for (var i = 0; i < myJson.features.length; i++) {
        var gmina_feature = myJson.features[i];
        let gmina_id = gmina_feature.id;
        gmina_feature.properties.n_ofert = gminy_counts[gmina_id] || 0;
        gmina_feature.properties.powierzch = (gminy_powierzch[gmina_id] || 0) .toFixed(2);
      }
      this.gminySource.addFeatures(
        this.gminySource.getFormat().readFeatures(myJson)
      );
      this.gminySource.forEachFeature(f => {
        let coordinates = getCenter(f.getGeometry().getExtent());
        let feature = new GeoJSON().readFeature({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coordinates
          }
        });
        feature.set("n_ofert", f.get("n_ofert"));
        feature.set("powierzch", f.get("powierzch"));
        feature.set("powiat_nazwa", f.get("powiat_nazwa"));
        feature.set("label", true);
        if (f.get("n_ofert") > 0) {
          this.gminyLabelsSource.addFeature(feature);
        }
      });
      this.gminy_source_cache = this.gminySource.getFeatures();
      this.gminy_labels_cache = this.gminyLabelsSource.getFeatures();
      this.map.on("singleclick", e => this.singleClickCallback(e));
      this.gminyLoaded = true;
      this.$root.$emit("gminyReady");
    },
    singleClickCallback(e) {
      if (document.getElementById("map").style.cursor == "crosshair") {
        return;
      }
      var selected = this.map.getFeaturesAtPixel(e.pixel, {
        hitTolerance: 5
      });
      if (selected) {
        let media = selected.find(f => f.get("layer") == "media");
        selected = selected.filter(f => f.get("label") != true);
        if (media) {
          this.modalMapMedia = media.getProperties();
          this.$modal.show("modal-map-media");
        } else if (this.ficzeryLayer.getVisible()) {
          let emitName;
          if (selected[0].get("status") == "zainwest") {
            emitName = "cartogramSelectOfertaS";
          } else if (selected[0].get("status") == "pod_inwest") {
            emitName = "cartogramSelectOferta";
          }
          if (emitName) {
            this.$root.$emit(emitName, {
              id: selected[0].get("id"),
              woj: selected[0].get("wojewodztwo_nazwa"),
              gmina: selected[0].get("gmina_nazwa"),
              powiat: selected[0].get("powiat_nazwa"),
              oferta: selected[0].get("nazwa")["pl"]
            });
          }
        } else if (this.powiatyLayer.getVisible()) {
          this.$root.$emit("cartogramSelectPowiat", selected[0].get("nazwa"));
        } else if (this.gminyLayer.getVisible()) {
          this.$root.$emit("cartogramSelectGmina", {
            gmina: selected[0].get("nazwa"),
            powiat: selected[0].get("powiat_nazwa")
          });
        } else {
          let emitName = "cartogramSelectOferta";
          if (selected[0].get("status") == "zainwest") {
            emitName = "cartogramSelectOfertaS";
          }
          this.$root.$emit(emitName, {
            id: selected[0].get("id"),
            woj: selected[0].get("wojewodztwo_nazwa"),
            gmina: selected[0].get("gmina_nazwa"),
            powiat: selected[0].get("powiat_nazwa"),
            oferta: selected[0].get("nazwa")["pl"]
          });
        }
      } else {
        if (this.powiatyLayer.getVisible() || this.gminyLayer.getVisible()) {
          this.$root.$emit("cartogramClearCollapse");
        } else {
          this.$store.dispatch("backGmina");
        }
      }
    },
    loadFiczery(data) {
      let myJson = undefined;
      if (data) {
        myJson = data;
      } else {
        myJson = this.offersJSON;
      }
      this.powiatySource.forEachFeature(f => {
        f.set("n_ofert", 0);
        f.set("powierzch", 0);
      });
      this.gminySource.clear();
      this.gminyLabelsSource.clear();
      this.powiatyLabelsSource.clear();
      this.ficzerySource.clear();
      this.gminy_source_cache = [];
      this.gminy_labels_cache = [];
      this.map.removeEventListener("singleclick");
      this.$root.$emit("gminyLoading");
      for (var i = 0; i < myJson.features.length; i++) {
        let powiat = myJson.features[i].properties.powiat_nazwa;
        let oferta_powierzch = myJson.features[i].properties.powierzch;
        this.powiatySource.forEachFeature(function(f) {
          if (f.get("nazwa") == powiat) {
            let n_ofert = 0;
            let powierzch = 0;
            if (f.get("n_ofert")) {
              n_ofert = f.get("n_ofert");
            }
            if (f.get("powierzch")) {
              powierzch = f.get("powierzch");
            }
            n_ofert++;
            powierzch = powierzch + oferta_powierzch;
            f.set("n_ofert", n_ofert);
            f.set("powierzch", powierzch);
            return false;
          }
        });
      }
      this.powiatySource.forEachFeature(f => {
        let coordinates = getCenter(f.getGeometry().getExtent());
        let feature = new GeoJSON().readFeature({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coordinates
          }
        });
        feature.set("n_ofert", f.get("n_ofert"));
        let area =
          f.get("powierzch") == undefined ? 0 : f.get("powierzch").toFixed(2);
        feature.set("powierzch", area);
        feature.set("label", true);
        if (f.get("n_ofert") > 0) {
          this.powiatyLabelsSource.addFeature(feature);
        }
      });
      let selectPointerMove = new Select({
        layers: [this.powiatyLayer, this.gminyLayer],
        condition: pointerMove,
        style: feature => {
          let style = new Style({
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.3)"
            }),
            stroke: new Stroke({ color: "rgba(0, 0, 0, 0.6)", width: 0.3 })
          });
          let n_ofert = feature.get("n_ofert");
          if (n_ofert == undefined) {
            return style;
          }
          if (n_ofert == 0) {
            style.getFill().setColor("rgba(255, 255, 255, 0.3)");
          } else if (n_ofert == 1) {
            style.getFill().setColor("rgba(218, 227, 243, 0.6)");
          } else if (n_ofert == 2) {
            style.getFill().setColor("rgba(202, 214, 235, 0.6)");
          } else if (n_ofert >= 3 && n_ofert <= 4) {
            style.getFill().setColor("rgba(189, 203, 227, 0.6)");
          } else if (n_ofert >= 5 && n_ofert <= 6) {
            style.getFill().setColor("rgba(183, 198, 224, 0.6)");
          } else if (n_ofert >= 7 && n_ofert <= 8) {
            style.getFill().setColor("rgba(170, 187, 217, 0.6)");
          } else if (n_ofert >= 9 && n_ofert <= 12) {
            style.getFill().setColor("rgba(149, 170, 206, 0.6)");
          } else {
            style.getFill().setColor("rgba(47, 85, 151, 0.6)");
          }
          style.setStroke(
            new Stroke({ color: "rgba(0, 32, 96, 0.6)", width: 2 })
          );
          return style;
        }
      });
      this.map.addInteraction(selectPointerMove);
      this.ficzerySource.addFeatures(
        this.ficzerySource.getFormat().readFeatures(myJson)
      );
      this.ficzery_source_cache = this.ficzerySource.getFeatures();
      this.$root.$emit("ficzery_source_cache", this.ficzery_source_cache);
      this.loadGminy(true);
    },
    initCartogram() {
      this.powiatyLayer = new VectorLayer({
        source: this.powiatySource,
        visible: true,
        name: "powiatyLayer",
        minResolution: this.map.getView().getResolutionForZoom(14),
        style: feature => {
          let style = this.defaultStyle.clone();
          let n_ofert = feature.get("n_ofert");
          if (!n_ofert) {
            n_ofert = 0;
          }
          let powierzch = feature.get("powierzch");
          if (!powierzch) {
            powierzch = 0;
          }
          if (n_ofert == 0) {
            style.getFill().setColor("rgba(255, 255, 255, 0.3)");
          } else if (n_ofert == 1) {
            style.getFill().setColor("rgba(218, 227, 243, 0.6)");
          } else if (n_ofert == 2) {
            style.getFill().setColor("rgba(202, 214, 235, 0.6)");
          } else if (n_ofert >= 3 && n_ofert <= 4) {
            style.getFill().setColor("rgba(189, 203, 227, 0.6)");
          } else if (n_ofert >= 5 && n_ofert <= 6) {
            style.getFill().setColor("rgba(183, 198, 224, 0.6)");
          } else if (n_ofert >= 7 && n_ofert <= 8) {
            style.getFill().setColor("rgba(170, 187, 217, 0.6)");
          } else if (n_ofert >= 9 && n_ofert <= 12) {
            style.getFill().setColor("rgba(149, 170, 206, 0.6)");
          } else {
            style.getFill().setColor("rgba(47, 85, 151, 0.6)");
          }
          style.setStroke(
            new Stroke({ color: "rgba(0, 0, 0, 0.6)", width: 0.3 })
          );
          return style;
        }
      });
      this.powiatyLabelsLayer = new VectorLayer({
        source: this.powiatyLabelsSource,
        visible: true,
        minResolution: this.map.getView().getResolutionForZoom(14),
        maxResolution: this.map.getView().getResolutionForZoom(7.5),
        style: f => {
          let style = this.defaultCircleStyle.clone();
          let n_ofert = f.get("n_ofert");
          if (!n_ofert) {
            n_ofert = 0;
          }
          let powierzch = f.get("powierzch");
          if (!powierzch) {
            powierzch = 0;
          }
          if (n_ofert > 0) {
            style.getText().setText(`${n_ofert}\n${powierzch} ha`);
          }
          return style;
        }
      });
      this.gminyLabelsLayer = new VectorLayer({
        source: this.gminyLabelsSource,
        visible: false,
        minResolution: this.map.getView().getResolutionForZoom(14),
        style: f => {
          let style = this.defaultCircleStyle.clone();
          let n_ofert = f.get("n_ofert");
          if (!n_ofert) {
            n_ofert = 0;
          }
          let powierzch = f.get("powierzch");
          if (!powierzch) {
            powierzch = 0;
          }
          style.getText().setText(`${n_ofert}\n${powierzch} ha`);
          return style;
        }
      });
      this.gminyLayer = new VectorLayer({
        source: this.gminySource,
        visible: false,
        name: "gminyLayer",
        minResolution: this.map.getView().getResolutionForZoom(14),
        style: feature => {
          var style = this.defaultStyle.clone();
          let n_ofert = feature.get("n_ofert");
          if (!n_ofert) {
            n_ofert = 0;
          }
          let powierzch = feature.get("powierzch");
          if (!powierzch) {
            powierzch = 0;
          }
          if (n_ofert == 0) {
            style.getFill().setColor("rgba(255, 255, 255, 0.3)");
          } else if (n_ofert == 1) {
            style.getFill().setColor("rgba(218, 227, 243, 0.6)");
          } else if (n_ofert == 2) {
            style.getFill().setColor("rgba(202, 214, 235, 0.6)");
          } else if (n_ofert >= 3 && n_ofert <= 4) {
            style.getFill().setColor("rgba(189, 203, 227, 0.6)");
          } else if (n_ofert >= 5 && n_ofert <= 6) {
            style.getFill().setColor("rgba(183, 198, 224, 0.6)");
          } else if (n_ofert >= 7 && n_ofert <= 8) {
            style.getFill().setColor("rgba(170, 187, 217, 0.6)");
          } else if (n_ofert >= 9 && n_ofert <= 12) {
            style.getFill().setColor("rgba(149, 170, 206, 0.6)");
          } else {
            style.getFill().setColor("rgba(47, 85, 151, 0.6)");
          }
          style.setStroke(
            new Stroke({ color: "rgba(0, 0, 0, 0.6)", width: 0.3 })
          );
          return style;
        }
      });
      this.ficzeryLayer = new VectorLayer({
        name: "ficzery",
        source: this.ficzerySource,
        visible: false,
        style: [
          new Style({
            stroke: new Stroke({ color: "rgba(41, 76, 112, 1)", width: 2 }),
            fill: new Fill({
              color: "rgba(41, 76, 112, 0.5)"
            })
          }),
          new Style({
            image: new Icon({
              anchor: [0.5, 46],
              anchorXUnits: "fraction",
              anchorYUnits: "pixels",
              src: "img/map-marker.svg"
            }),
            geometry: feature => {
              let geomExtent = feature.getGeometry().getExtent();
              return new Point(getCenter(geomExtent));
            }
          })
        ]
      });
      this.$http.get("/jst_pub/powiaty.geojson").then(myJson => {
        this.powiatySource.addFeatures(
          this.powiatySource.getFormat().readFeatures(myJson.data)
        );
        this.map.addLayer(this.powiatyLayer);
        this.map.addLayer(this.powiatyLabelsLayer);
        this.map.addLayer(this.gminyLayer);
        this.map.addLayer(this.gminyLabelsLayer);
        this.map.addLayer(this.ficzeryLayer);
        this.selectionLayer = new VectorLayer({
          source: new VectorSource(),
          visible: true,
          name: "selection",
          style: new Style({
            fill: new Fill({
              color: "rgba(255,255,255, 0)"
            }),
            stroke: new Stroke({ color: "rgba(0,175,243, 1)", width: 4 })
          }),
          zIndex: 1
        });
        this.map.addLayer(this.selectionLayer);
        if (!this.offersJSON.features) {
          let unwatch = this.$watch("offersJSON", () => {
            this.loadFiczery();
            unwatch();
          });
        } else {
          this.loadFiczery();
        }
      });
    },
    initHover() {
      const div = document.createElement("div");
      div.className = "map-overlay";
      div.style.display = "none";
      let overlay = new Overlay({
        offset: [15, 15],
        element: div
      });
      this.map.addOverlay(overlay);
      const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
      this.map.on("pointermove", e => {
        if (e.dragging) {
          return;
        }
        let selected = this.map.getFeaturesAtPixel(e.pixel);
        if (selected) {
          let feature = this.map
            .getFeaturesAtPixel(e.pixel)
            .filter(f => f.get("label") != true)[0];
          if (feature) {
            if (typeof feature.get("nazwa") === "string") {
              let name;
              if (feature.get("powiat_nazwa")) {
                // Gmina
                div.className = "map-overlay map-overlay-gmina";
                name = `Gmina m. ${capitalize(
                  feature.get("nazwa").replace("gmina", "")
                )}`;
              } else {
                // Powiat
                div.className = "map-overlay map-overlay-powiat";
                name = `Powiat ${capitalize(feature.get("nazwa"))}`;
              }
              div.innerHTML = `
                <div>${name}</div>
                <div class="map-overlay-offer-count">${this.$t("map.offerCount")} ${feature.get("n_ofert") || 0}</div>
                <div class="map-overlay-click-to-see">${this.$t("map.clickToSeeOffer")}</div>
              `
            } else if (feature.get("nazwa")) {
              let oferta;
              // pod_inwest - Oferta
              // zainwest - Inwestor
              if (feature.get('status') === 'pod_inwest') {
                // Oferta
                div.className = "map-overlay map-overlay-oferta";
                oferta = true;
              } else {
                // Inwestor
                div.className = "map-overlay map-overlay-inwestor";
                oferta = false;
              }
              div.innerHTML = `
                <div>${feature.get("nazwa")[this.$i18n.i18next.language]}</div>
                <div>
                  <img
                      src="${imgToSmallSrc(feature.get("zdjecia")[0])}"
                  />
                </div>
                <div>${oferta ? this.$t("map.clickToSeeOffer") : this.$t("map.clickToSeeInvestor")}</div>
              `

            } else if (feature.get(`etykieta_${this.$i18n.i18next.language}`)) {
              // etykieta
              div.className = "map-overlay map-overlay-etykieta";
              div.innerHTML = feature.get(
                `etykieta_${this.$i18n.i18next.language}`
              );
            } else {
              div.style.display = "none";
              return;
            }
            overlay.setPosition(e.coordinate);
            div.style.display = "block";
          }
        } else {
          div.style.display = "none";
        }
      });
    },
    addedSource(name, source) {
      if (this.sourcesLoading[name] !== undefined) {
        source.on("tileloadstart", () => {
          this.sourcesLoading[name] += 1;
        });

        source.on("tileloadend", () => {
          setTimeout(() => {
            this.sourcesLoading[name] -= 1;
          }, 250);
        });
        source.on("tileloaderror", () => {
          setTimeout(() => {
            this.sourcesLoading[name] -= 1;
          }, 250);
        });
      }
    },
    addBasemaps() {
      for (let layer of this.basemapLayers) {
        if(layer.type === 'wms'){
          const source_data = {
            url: layer.url,
            params: {
              LAYERS: layer.layers,
              TILED: true
            },
            transition: 0,
            crossOrigin: "anonymous"
          };
          if (layer.projection) {
            source_data.projection = layer.projection;
          }
          const source = new TileWMS(source_data);
          this.map.addLayer(
            new TileLayer({
              name: `basemap-${layer.name}`,
              visible: false,
              source
            })
          );
        } else if(layer.type === 'wmts') {
          const serviceLayer = new TileLayer({
            name: `basemap-${layer.name}`,
            visible: true,
            source: new WMTS({
              matrixSet: layer.CRS,
              url: layer.url,
              projection: getProjection(layer.CRS),
              tileGrid: new WMTSTileGrid(layer.parameters),
              wrapX: true,
            }),
          });
          this.map.addLayer(serviceLayer);
        } else {
          this.map.addLayer(
            new TileLayer({
              visible: false,
              source: new XYZ({
                url: layer.url,
                crossOrigin: "anonymous"
              }),
              name: `basemap-${layer.name}`
            })
          );
        }
      }
    },
    addWMSLayers() {
      for (let layer of this.wmsLayers) {
        let source_data = {
          url: layer.url,
          params: {
            LAYERS: layer.layers,
            TILED: true
          },
          transition: 0,
          crossOrigin: "anonymous"
        };
        if (layer.projection) {
          source_data.projection = layer.projection;
        }
        let source;
        if (layer.type == "wms") {
          source = new TileWMS(source_data);
          this.map.addLayer(
            new TileLayer({
              name: `wms-${layer.name}`,
              visible: false,
              source
            })
          );
        } else if (layer.type == "swms") {
          source = new ImageWMS(source_data);
          this.map.addLayer(
            new ImageLayer({
              name: `wms-${layer.name}`,
              visible: false,
              source
            })
          );
        } else if (layer.type == "wmts") {
          source = new WMTS({
            url: layer.url,
            layer: layer.layers,
            matrixSet: "EPSG:3857",
            format: "image/png",
            tileGrid: this.wmtsTilegrid
          });
          this.map.addLayer(
            new TileLayer({
              source,
              name: `wms-${layer.name}`,
              visible: false
            })
          );
        }
        this.addedSource(layer.name, source);
      }
    },
    resetExtent() {
      this.map.getView().animate({
        center: fromLonLat([16.706, 51.105]),
        zoom: 8,
        duration: 1000
      });
      if (this.haleLayer) {
        this.haleLayer.setZIndex(0);
      }
      if (this.biuraLayer) {
        this.biuraLayer.setZIndex(0);
      }
    },
    selectHala(item) {
      let feature = this.haleLayer
        .getSource()
        .getFeatures()
        .filter(f => f.get("id") == item.id)[0];
      this.map.getView().fit(feature.getGeometry().getExtent(), {
        duration: 1000
      });
      this.haleLayer.setZIndex(1);
    },
    selectBiuro(item) {
      let feature = this.biuraLayer
        .getSource()
        .getFeatures()
        .filter(f => f.get("id") == item.id)[0];
      this.map.getView().animate({
        zoom: 18,
        center: feature.getGeometry().getCoordinates(),
        duration: 1000
      });
      this.biuraLayer.setZIndex(1);
    }
  },
  mounted() {
    this.loadGminy(false);
    window.mapVue = this;
    proj4.defs(
      "EPSG:2180",
      "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs +axis=enu"
    );
    register(proj4);
    this.$root.$on("ofertyReady", myJson => {
      this.offersJSON = myJson;
    });
    this.$root.$on("ofertyZainwestReady", myJson => {
      this.offersJSONZainwest = myJson;
      this.ficzeryZainwestLayer = new VectorLayer({
        name: "ficzeryZainwest",
        source: new VectorSource({
          features: new GeoJSON().readFeatures(myJson, {
            featureProjection: "EPSG:3857"
          })
        }),
        visible: false,
        style: [
          new Style({
            stroke: new Stroke({ color: "rgba(127, 127, 127, 1)", width: 2 }),
            fill: new Fill({
              color: "rgba(213, 213, 213, 0.5)"
            })
          }),
          new Style({
            image: new Icon({
              anchor: [0.5, 46],
              anchorXUnits: "fraction",
              anchorYUnits: "pixels",
              src: "img/map-marker-grey.svg"
            }),
            geometry: feature => {
              let geomExtent = feature.getGeometry().getExtent();
              return new Point(getCenter(geomExtent));
            }
          })
        ]
      });
      this.map.addLayer(this.ficzeryZainwestLayer);
    });
    var scaleLineControl = new ScaleLine();

    this.map = window.map = new Map({
      layers: [],
      target: "map",
      view: new View({
        center: fromLonLat([16.706, 51.105]),
        zoom: 8
      }),
      controls: defaultControls().extend([scaleLineControl])
    });
    this.addBasemaps();
    this.basemap = "light";
    this.addWMSLayers();
    this.makePNG();
    this.editingSource = new VectorSource();
    this.map.addLayer(
      new VectorLayer({
        source: this.editingSource
      })
    );
    this.initCartogram();
    this.initHover();
    this.loadMVT();
    this.map.on("moveend", e => {
      let zoom = e.map.getView().getZoom();
      this.currentZoom = zoom;
      if (zoom > 10 && this.cartogramActive == false) {
        if (this.powiatyLayer.getVisible()) {
          this.powiatyLayer.setVisible(false);
          this.powiatyLabelsLayer.setVisible(false);
          this.gminyLayer.setVisible(true);
          this.gminyLabelsLayer.setVisible(true);
        }
        if (zoom > 14 && this.ficzeryLayer.getVisible() == false) {
          this.setLayerVisibility("ficzery", true);
          this.setLayerVisibility("ficzeryZainwest", true);
        }
      } else if (this.cartogramActive == false) {
        if (this.gminyLayer.getVisible()) {
          this.powiatyLayer.setVisible(true);
          this.powiatyLabelsLayer.setVisible(true);
          this.gminyLayer.setVisible(false);
          this.gminyLabelsLayer.setVisible(false);
        }
      }
      if (zoom <= 14 && this.cartogramActive == false) {
        this.setLayerVisibility("ficzery", false);
        this.setLayerVisibility("ficzeryZainwest", false);
      }
    });
    this.$root.$emit("mainMap", this.map);
    this.$root.$on("haleReady", data => {
      let vectorSource = new VectorSource({
        format: new GeoJSON({ featureProjection: "EPSG:3857" })
      });
      vectorSource.addFeatures(
        vectorSource.getFormat().readFeatures({
          type: "FeatureCollection",
          features: data.features.map(f => {
            return {
              type: "Feature",
              geometry: f.geometry,
              properties: {
                id: f.id,
                nazwa: f.properties.nazwa
              }
            };
          })
        })
      );
      this.haleLayer = new VectorLayer({
        name: "hale-layer",
        source: vectorSource,
        maxResolution: this.map.getView().getResolutionForZoom(14),
        visible: true,
        style: new Style({
          stroke: new Stroke({ color: "white", width: 2 }),
          fill: new Fill({
            color: "rgba(84, 184, 200, 0.6)"
          })
        })
      });
      this.map.addLayer(this.haleLayer);
    });
    this.$root.$on("biuraReady", data => {
      let vectorSource = new VectorSource({
        format: new GeoJSON({ featureProjection: "EPSG:3857" })
      });
      vectorSource.addFeatures(
        vectorSource.getFormat().readFeatures({
          type: "FeatureCollection",
          features: data.features.map(f => {
            return {
              type: "Feature",
              geometry: f.geometry,
              properties: {
                id: f.id,
                nazwa: f.properties.nazwa
              }
            };
          })
        })
      );
      this.biuraLayer = new VectorLayer({
        name: "biura-layer",
        source: vectorSource,
        visible: true,
        maxResolution: this.map.getView().getResolutionForZoom(14),
        style: new Style({
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({
              color: "rgba(84, 184, 200, 0.6)"
            }),
            stroke: new Stroke({
              color: "white"
            })
          })
        })
      });
      this.map.addLayer(this.biuraLayer);
    });
  }
};
</script>
<style lang="scss">
.measure {
  height: 42px;
  min-width: 100px;
  position: absolute;
  z-index: 1;
  top: 50px;
  left: 585px;
  padding-top: 3px;
  padding-right: 3px;
  padding-left: 3px;
  padding-bottom: 1px;
}
.measure-inner {
  background-color: rgba(0, 60, 136, 0.5);
  color: white;
  font: 400 13.3333px Arial;
  padding: 3px;
}

.map-loadings {
  display: flex;
  flex-direction: column;
  align-items: center;

  position: fixed;
  right: 0;
  bottom: 100px;
  z-index: 1;

  transition: all 0.3s;

  .map-loadingg-loading {
    color: #294c70;
    font-weight: bold;

    $stroke-color: white;
    text-shadow: -1px -1px 0 $stroke-color, 1px -1px 0 $stroke-color,
      -1px 1px 0 $stroke-color, 1px 1px 0 $stroke-color;

    display: flex;
    align-items: center;

    text-align: center;
    font-size: 1rem;

    i {
      padding: 0.5rem;
      font-size: 1.5rem;
    }
  }
}

@media (min-width: 1550px) {
  .map-loadings {
    bottom: 20px;
  }
}

.map-layers-btns {
  display: flex;
  align-items: stretch;

  .map-layers-shortcuts {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    padding: 10px 0;
    list-style: none;

    margin-bottom: 0;

    label {
      margin-bottom: 0;
    }
  }
}

.modal-map-media {
  table {
    margin-bottom: 1rem;
    td {
      padding: 0.5rem;
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
  }
}

.map-overlay {
  position: relative; /* correct position (top-left corner to mouse) */
  padding: 5px 10px;
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.3);

  &.map-overlay-gmina, &.map-overlay-powiat {
    width: auto;
    height: auto;
    color: white;
    background: #002f67;
    font-weight: bold;

    .map-overlay-offer-count {
      color: lime;
    }
    .map-overlay-click-to-see {
      font-style: italic;
    }
  }

  &.map-overlay-etykieta {
    width: auto;
    height: auto;
    color: white;
    background: rgb(189, 189, 189);
  }

  &.map-overlay-oferta, &.map-overlay-inwestor {
    width: 200px + 2 * 10px;
    height: auto;
    text-align: center;
    font-weight: bold;

    img {
      max-width: 200px;
      max-height: 200px;
      border: 2px solid;
      background-color: white;
    }
  }

  &.map-overlay-oferta {
    color: white;
    background: #002f67;
    img {
      border-color: white;
    }
  }

  &.map-overlay-inwestor {
    color: white;
    background: rgb(189, 189, 189);
    img {
      border-color: black;
    }
  }
}
</style>
 